import { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { toast } from 'sonner';
import AuthService from 'services/authService';
import AuthLayout from 'layouts/AuthLayout';

export default function RegisterPage() {
  const navigate = useNavigate();
  const [username, setUsername] = useState('');
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');

  const handleRegister = (e) => {
    e.preventDefault();
    AuthService.register({ username, email, password }).then((response) => {
      if (response.status === 'Success') {
        toast.success(response.message);
        setTimeout(() => {
          navigate('/login', { replace: true });
        }, 1000);
      }
    });
  };

  return (
    <AuthLayout>
      <div className="max-w-md w-full space-y-8">
        <div
          className="
          h-fit
          bg-[#202020]
          px-8 pt-12 pb-10
          rounded-xl
          text-white
          "
        >
          <h1 className="text-4xl font-light">Register Page</h1>

          <div className="mt-8">
            <input
              className="
                w-full
                bg-[#292929]
                outline-none
                rounded-lg px-3 p-4 mt-2
                "
              placeholder="Username"
              onChange={(e) => setUsername(e.target.value)}
            />
            <input
              className="
                w-full
                bg-[#292929]
                outline-none
                rounded-lg px-3 p-4 mt-2
                "
              type="email"
              placeholder="Email"
              onChange={(e) => setEmail(e.target.value)}
            />
            <input
              className="
                w-full
                bg-[#292929]
                outline-none
                rounded-lg px-3 p-4 mt-2
                "
              type="password"
              placeholder="Password"
              onChange={(e) => setPassword(e.target.value)}
            />
            <div className="mt-5">
              <button type="submit" className="submit w-full rounded-lg p-4 bg-indigo-500 hover:bg-indigo-600 text-white" onClick={handleRegister}>
                Register
              </button>
            </div>
            <div className="flex justify-center gap-1 mt-3 text-sm italic">
              <p>Have an account?</p>
              <Link to="/login" className="text-indigo-300">
                Login
              </Link>
            </div>
          </div>
        </div>
      </div>
    </AuthLayout>
  );
}
